import { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { menuDb } from "../../constants/data";
import { Link } from "react-router-dom";
import LanguageSwitcher from "../common/LanguageSwitcher";
import logoImg from '../../assets/images/logo/MesoftLogo.avif';
import settings from "../../constants/settings";

const Header = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openSubmenus, setOpenSubmenus] = useState({});
  const headerRef = useRef(null);
  const overlayRef = useRef(null);
  const { t } = useTranslation();
  const [activeMenu, setActiveMenu] = useState(null);
  const isRTL = typeof window !== 'undefined' && document?.dir === 'rtl';
  const { pathname } = useLocation();
  const logoRef = useRef(null);
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const navToggle = (is_close) => {
    setIsMenuOpen(!is_close);

    if (headerRef.current && overlayRef.current) {
      const overlayHeight = window.innerHeight;
      overlayRef.current.style.height = is_close ? `${overlayHeight}px` : '0';
    }
  };

  useEffect(() => {
    navToggle(false); // Start with menu closed

    // gsap.from(logoRef.current, {
    //   // x: 150,          // slide in from the left
    //   opacity: 0,
    //   duration: 3,
    //   scale: 1.2,
    //   // ease: 'power3.out',
    //   ease: 'back.out(1.8)', // Adds a nice elastic pop
    // });

    const handleScroll = () => {
      const scrollY = window.scrollY;
      setHasScrolled(scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleSubmenu = (id) => {
    setOpenSubmenus((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const DownArrow = ({ isOpen }) => (
    <svg
      className={`w-4 h-4 ml-2 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
      fill="#ffffff"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  );

  const menuIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" className="text-black" width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="15" y1="12" x2="10" y2="12"></line>
      <line x1="3" y1="6" x2="21" y2="6"></line>
      <line x1="3" y1="18" x2="21" y2="18"></line>
    </svg>
  );

  const closeIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" className="text-black" width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  );

  return (
    <header
      ref={headerRef}
      className="bg-white"
    >
      <div className="md:w-theme-container w-mobile-container h-16 md:h-24 mx-auto flex justify-between items-center">
        <div className="w-3/5-open-if-need flex items-center justify-start">
          <div
            // ref={logoRef}
            className="w-36 md:w-44 lg:w-48 bg-yellow-3000">
            <Link
              to={settings.domain}
              className="">
              <img src={logoImg} className="w-full" alt="Logo" />
            </Link>
          </div>
        </div>
        <div
          className="xl:hidden nav-btn"
          style={{ zIndex: 9999, position: 'relative' }}
          onClick={() => navToggle(isMenuOpen)}
        >
          <div className="btn w-8 h-8 nav-icon-place">
            {isMenuOpen ? menuIcon : closeIcon}
          </div>
        </div>

        {/* Mobile Overlay Menu */}
        <div
          ref={overlayRef}
          className="overlay w-full h-0 xl:hidden bg-white text-black flex justify-center items-center transition-all duration-300"
          style={{ zIndex: 10, position: 'fixed', top: 0, left: 0 }}
        >
          <div className="relative top-0 flex flex-col items-start w-11/12">
            {menuDb.mainMenu.map((item) => (
              <div key={item.id} className="w-full">
                {item.submenu ? (
                  <div className="w-full">
                    <div
                      className="flex justify-between items-center w-full pt-6 border-b border-black cursor-pointer"
                      onClick={() => toggleSubmenu(item.id)}
                    >
                      <p className="text-2xl">{item.title}</p>
                      <DownArrow isOpen={openSubmenus[item.id]} />
                    </div>
                    {openSubmenus[item.id] && (
                      <ul className="pl-4 mt-2">
                        {item.submenu.map((subItem) => (
                          <li key={subItem.id} className="py-2 border-b border-gray-300">
                            <Link
                              className="text-gray-600 text-lg"
                              to={subItem.routePath}
                              onClick={() => navToggle(isMenuOpen)}
                            >
                              {subItem.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ) : (
                  <Link
                    className="block w-full"
                    to={item.routePath}
                    onClick={() => navToggle(isMenuOpen)}
                  >
                    <p className="text-2xl pt-6 border-b border-black">{item.title}</p>
                  </Link>
                )}
              </div>
            ))}
            <p className="text-sm mt-20 text-left w-full text-black">
              We Have Been in the Industry Since 2000
            </p>
            <div className="overlay-footer mt-3">
              <div className="flex space-x-4">
                <a className="underline hover:text-theme-color text-black" target="_blank" href="https://www.linkedin.com/company/mesoft-business-solutions-l-l-c/">LinkedIn</a>
                <a className="underline hover:text-theme-color text-black" target="_blank" href="https://www.instagram.com/mesoftuae">Instagram</a>
              </div>
            </div>
          </div>
        </div>

        {/* Desktop Menu */}
        <div className="hidden xl:block w-10/12-do-not-need w-1/2">
          <ul className="flex items-center justify-between main-nav-append gap-3">
            {menuDb.mainMenu.map((item) => (
              <li key={item.id} className="main-menu-id group cursor-pointer relative">
                {item.submenu ? (
                  <div
                    className="relative flex justify-start"
                    onMouseEnter={() => setActiveMenu(item.id)}
                    onMouseLeave={() => setActiveMenu(null)}
                  >
                    {/* Main menu item with dropdown indicator */}
                    <div
                      className={`${'/'+pathname?.split('/')[1]===item.routePath&&"text-theme-color"} text-lg text-black flex items-center gap-1 py-2 px-2 hover:text-theme-color rounded transition-colors`}
                    >
                      {t(`common.${item.translateKey}`)}
                      <svg
                        className="w-4 h-4 ml-1 transition-transform group-hover:rotate-180"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                      </svg>
                    </div>
                    {/* Submenu dropdown with card-style UI */}
                    <ul
                      className={`
                      ${item.routePath==='/products'?"w-[1100pxxxxxx]":"w-[755pxxxxxxx]"} 
                      ${isRTL?'md:mr-[-480px] lg:mr-[-300px]':'md:ml-[-500px] lg:ml-[-440px]'}
                      w-[1100px]
                      p-5 border bg-white absolute top-full mt-1 border-theme-color rounded-lg shadow-lg transition-all duration-200 transform z-30 
                      ${
                        activeMenu === item.id
                          ? 'opacity-100 visible translate-y-0'
                          : 'opacity-0 invisible translate-y-1'
                      }`}
                    >
                      <div className="flex items-center justify-center">
                        <div className="text-center text-xl font-medium text-black mb-2">
                          {t(`common.${item.translateKey}`)}
                        </div>
                      </div>
                      {/*<div className="flex justify-start items-center flex-wrap gap-3">*/}
                      <div className="grid grid-cols-3 gap-5">
                        <div className="left-card col-span-1">
                          {/* Render the first submenu item here */}
                          {item.submenu.length > 0 && item.submenu[0].hideShow && (
                            <Link
                              key={item.submenu[0].id}
                              to={item.submenu[0].routePath}
                              onClick={() => setActiveMenu(null)}
                              className={`
                                h-full flex flex-col hover:shadow-lg rounded-xl overflow-hiddennn group/subitem transition-all 
                                ${pathname===item.submenu[0].routePath?"border-theme-color":"border-gray-200"} hover:border-theme-color`
                              }
                            >
                              <div className="relative w-full h-auto rounded-lg overflow-hidden">
                                <img
                                  src={require(`../../assets/images/menu/${item.submenu[0].menuImg}`)}
                                  alt={item.submenu[0].title}
                                  className="w-full h-auto object-cover"
                                />
                                <div className="absolute inset-0 bg-black bg-opacity-25" />
                                <div className="absolute inset-0 flex items-end justify-start mb-5 ml-5">
                                  <h2 className="text-white text-lg">{item.submenu[0].title}</h2>
                                </div>
                              </div>
                            </Link>
                          )}
                        </div>
                        <div className="right-card col-span-2 grid grid-cols-2 gap-5">
                          {/* Render all submenu items except the first one */}
                          {item.submenu
                            .slice(1)
                            .filter((subItem) => subItem.hideShow)
                            .map((subItem) => (
                              <Link
                                key={subItem.id}
                                to={subItem.routePath}
                                onClick={() => setActiveMenu(null)}
                                className={`bg-white hover:shadow-lg rounded-lg group/subitem transition-all ${pathname===subItem.routePath?"border-theme-color":"border-gray-200"} hover:border-theme-color`}
                              >
                                <div className="relative w-full h-auto rounded-lg overflow-hidden">
                                  <img
                                    src={require(`../../assets/images/menu/${subItem.menuImg}`)}
                                    alt={subItem.title}
                                    className="w-full h-auto object-cover"
                                  />
                                  <div className="absolute inset-0 bg-black bg-opacity-25" />
                                  <div className="absolute inset-0 flex items-end justify-start mb-5 ml-5">
                                    <h2 className="text-white text-lg">{subItem.title}</h2>
                                  </div>
                                </div>
                              </Link>
                          ))}
                        </div>
                      </div>
                    </ul>
                  </div>
                ) : (
                  <Link
                    className={`${pathname===item.routePath&&"text-theme-color"} text-lg text-black py-2 px-3 hover:text-theme-color rounded transition-colors`}
                    to={item.routePath}
                  >
                    {t(`common.${item.translateKey}`)}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>
        <div className="hidden xl:block float-end">
          <LanguageSwitcher/>
        </div>
      </div>
    </header>
  );
};

export default Header;
